import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { listAccessAudits } from "@/lib/access-audit.functions";

export const Route = createFileRoute("/admin/erisim-denetimi")({
  head: () => ({ meta: [{ title: "Erişim denetimi · Yönetim" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: AccessAudit,
});

function AccessAudit() {
  const fetchAll = useServerFn(listAccessAudits);
  const { data, isLoading, error } = useQuery({ queryKey: ["access-audits"], queryFn: () => fetchAll() });
  return (
    <div className="mx-auto max-w-3xl p-6">
      <h1 className="text-2xl font-semibold">Erişim denetimi</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        Her pazartesi 09:00'da canlı sitede herkese açık sayfalar, giriş, yönetim sayfası, robots.txt ve özel verilerin dışarıya kapalı olduğu kontrol edilir. Yalnızca bulgular listelenir.
      </p>
      {isLoading && <p className="mt-6 text-sm">Yükleniyor…</p>}
      {error && <p className="mt-6 text-sm text-destructive">Kayıtlar yüklenemedi.</p>}
      {data && data.length === 0 && <p className="mt-6 text-sm">Henüz denetim çalışmadı; ilk denetim pazartesi 09:00'da.</p>}
      <ul className="mt-6 space-y-3">
        {data?.map((r) => (
          <li key={r.id} className="rounded-md border border-border p-4">
            <div className="flex items-center justify-between text-sm">
              <span>{new Date(r.ran_at).toLocaleString("tr-TR", { timeZone: "Europe/Istanbul" })}</span>
              <span className={r.ok ? "text-muted-foreground" : "font-medium text-destructive"}>
                {r.ok ? `Bulgu yok (${r.checks_total} kontrol)` : `${r.findings.length} bulgu`}
              </span>
            </div>
            {!r.ok && (
              <ul className="mt-2 list-disc pl-5 text-sm">
                {r.findings.map((f, i) => <li key={i}><strong>{f.check}:</strong> {f.detail}</li>)}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
